/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoInternalModelsForwardLinkListItem,
    MelcoInternalModelsForwardLinkListItemFromJSON,
    MelcoInternalModelsForwardLinkListItemFromJSONTyped,
    MelcoInternalModelsForwardLinkListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItem
 */
export interface MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItem {
    /**
     * 
     * @type {Array<MelcoInternalModelsForwardLinkListItem>}
     * @memberof MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItem
     */
    list: Array<MelcoInternalModelsForwardLinkListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItemFromJSON(json: any): MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItem {
    return MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoInternalModelsForwardLinkListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItemToJSON(value?: MelcoModelsGenericList1MelcoInternalModelsForwardLinkListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoInternalModelsForwardLinkListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


